import axios from "axios";
import { getAuthorizationHeader } from "./auth_service";

export const deleteOfferApply = async (id) => {
  let res = await axios.delete(
    process.env.REACT_APP_BACKEND_URL + `api/job-offer-applies/${id}`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getOfferApply = async (id) => {
  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/job-offer-applies/${id}?populate=*`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

